var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoCard',{staticClass:"additional-info-container",attrs:{"icon":"iconfont icona-ApplicationConfiguration","title":_vm.$t(`${_vm.i18nPrefix}.title.additionalInfo`),"infoList":_vm.infoList,"infoLines":_vm.infoLines}})
}
var staticRenderFns = []

export { render, staticRenderFns }